import gsap from "../../js/gsap/gsap.min.js";
import { Flip } from "../../js/gsap/Flip.min.js";
gsap.registerPlugin(Flip);

;(function initPropertyFilter() {

  const START_SLUG = "current-projects";   // ← set to the real slug of the Current Projects tag

  const grid = document.querySelector("#all-properties-grid");
  if (!grid) return;

  const filters = [...document.querySelectorAll(".property-filter a")];
  const allBtn  = document.querySelector('.property-filter a[data-term="0"]');
  if (!filters.length || !allBtn) return;

  let activeTerm = null;               // null = All, otherwise a single term id
  let busy = false;                    // prevents overlapping Flips

  function cards() {
    return gsap.utils.toArray("#all-properties-grid .property-card");
  }

  function matches(card) {
    return activeTerm === null || card.classList.contains("term-" + activeTerm);
  }

  function setActive(btn) {
    filters.forEach(el => el.classList.remove("active"));
    btn.classList.add("active");
    activeTerm = btn.dataset.term === "0" ? null : btn.dataset.term;
  }

  function applyFilter() {
    if (busy) return;
    busy = true;

    const items = cards();
    const state = Flip.getState(items);          // capture BEFORE display change

    items.forEach(item => {
      item.style.display = matches(item) ? "" : "none";
    });

    Flip.from(state, {
      duration: 0.7,
      scale: true,
      absolute: true,
      ease: "power1.inOut",
      onEnter: els => gsap.fromTo(els,
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1, duration: 0.7 }),
      onLeave: els => gsap.to(els,
        { opacity: 0, scale: 0, duration: 0.7 }),
      onComplete: () => { busy = false; }
    });
  }

  filters.forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      if (btn.classList.contains("active")) return;   // already selected → no-op
      setActive(btn);
      applyFilter();
    });
  });

  // --- start on Current Projects ---
  const startBtn = filters.find(el => el.dataset.slug === START_SLUG);
  if (startBtn) {
    setActive(startBtn);
    applyFilter();
  }

})();
